<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<div class="titg">
<h1 class="title"><span class="navy">super</span></h1>
<h1 class="title1"><span class="white"><span class="bold">simple</span> quilts</span></h1>
<div class="tit">
<p class="num">#<span class="fontw">3</span></p>
</div>
<p class="author"><span class="smallw">WITH</span> ALEX ANDERSON &amp; LIZ ANELOSKI</p>
</div>
<div class="titb">
<p class="text">9 Pieced Projects from Strips, Squares &amp; Triangles</p>
</div>
<div class="titg1">
<div class="img_containerz">
<img alt="images" src="images/f0001-01.jpg"/>
</div>
<div class="img_containerz1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?98a29a16